<script setup lang="ts">
const props = defineProps<{
  label?: string;
  title: string;
  centered?: boolean;
  class?: string;
  small?: boolean;
}>()
</script>


<template>
  <div 
    class="brand-heading mb-8" 
    :class="[
      centered ? 'text-center' : '', 
      props.class,
      small ? 'brand-heading-small' : ''
    ]"
  >
    <span v-if="label" class="text-neon uppercase tracking-widest font-bold text-sm mb-2 block">
      {{ label }}
    </span>
    <h2 
      class="gradient-text font-bold leading-tight m-0 pb-2 pr-4" 
      :class="[small ? 'text-2xl md:text-3xl' : 'text-4xl md:text-5xl lg:text-6xl']"
      v-html="title"
    ></h2>

  </div>

</template>


